export default __webpack_public_path__ + "static/media/Volo.9c82917f.jpg";